export function rbtShowTags(event) {
    let showTagsButton = event.target.classList.contains('show-tags') ? event.target : event.target.closest('.show-tags');
    let tags = showTagsButton.nextElementSibling;
    if (!tags.classList.contains('post-tags')) return;
    let textInner = showTagsButton.querySelector('.text-inner');

    if (showTagsButton.classList.contains('active')) {
        showTagsButton.classList.remove('active');
        tags.classList.remove('active');
        textInner.innerHTML = 'show tags';
    } else {
        showTagsButton.classList.add('active');
        tags.classList.add('active');
        textInner.innerHTML = 'hide tags';
    }

}